<template>
	<div class="lib-search">
		<div class="row">
			<div class="col-md-8 col-lg-6">
				<div class="form-item">
					<div class="input-custom-icon">
						<input
							v-model.lazy="keyword"
							v-debounce="300"
							type="text"
							placeholder="Tìm kiếm"
							class="form-30h form-bg-gray-light border-rd-20 full-width"
						/>
						<i class="icon-search primary-color"></i>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import { mapState, mapActions } from 'vuex'
	import { STORE_KEY } from './../../_store/constants'
	import debounce from '@/directives/debounce'

	export default {
		name: 'FilterForm',
		directives: { 
			debounce
		},
		data () {
			return {
				keyword: ''
			}
		},
		computed: {
			...mapState(STORE_KEY, ['paramSearchLessons']),
		},
		watch: {
			keyword: "filterDataByKeyword"
		},
		methods: {
			...mapActions(STORE_KEY, ['setParamSearchLesson']),

			filterDataByKeyword(val) {
				this.setParamSearchLesson({...this.paramSearchLessons, keyword: val})
			}
		}
	}
</script>

<style lang="css" scoped>
</style>